import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";


@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PagesComponent implements OnInit {

  public slug;
  public page = {
    title: '',
    slug: '',
    cover_image: '',
    content: '<h1>404</h1>'
  };

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
    });

    this.getPage(this.slug);
  }

  getPage(slug) {
    this.slug = slug;
    this.http.get(Conf.API_URL + '/pages/?slug=' + this.slug).subscribe(
        data => {
          if (data['results']) {
            this.page = data['results'][0];
          }
        },
        error => {
          console.log(error.error)
        }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/pages/pages.component.ts